import { Alert, AlertTitle, Button, Stack } from '@mui/material'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import BugReportButton from './BugReportButton'

export interface ErrorStateProps {
  error?: unknown
}

export default function ErrorState({ error }: ErrorStateProps) {
  const { t } = useTranslation('common')

  const navigate = useNavigate()

  const isAxiosError = axios.isAxiosError(error)

  const isAccessDenied = isAxiosError && error?.response?.status === 403

  const isNotFound = isAxiosError && error?.response?.status === 404

  const severity = isNotFound ? 'info' : 'error'

  return (
    <>
      <Alert
        severity={severity}
        sx={{
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          p: 10,
          '& .MuiAlert-icon': {
            fontSize: 64,
            justifyContent: 'center',
            alignItems: 'center',
            margin: 0
          },
          '& .MuiAlert-message': {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }
        }}
      >
        <AlertTitle variant="h3" mb={4}>
          {isAccessDenied
            ? t('accessDenied')
            : isNotFound
              ? t('notFound')
              : t('somethingWentWrong')}
        </AlertTitle>

        <Stack direction="row" alignItems="center" spacing={3}>
          <Button variant="outlined" size="large" color={severity} onClick={() => navigate(-1)}>
            {t('back')}
          </Button>
          <BugReportButton variant="contained" size="large" color={severity} />
        </Stack>
      </Alert>
    </>
  )
}
